
define(
	'CustomPageModule'

,   [
		'ArticlePageModule.View',
        'InstructionPageModule.View',
        'ToolPageModule.View',
        'ProductOverviewPageModule.View',
		'Utils'
	]
,   function (
		ArticlePageModuleView,
        InstructionPageModuleView,
        ToolPageModuleView,
        ProductOverviewPageModuleView,
		Utils
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

			/** Page Type Test */

			var pageType = container.getComponent('PageType');

			pageType.registerPageType({
				'name': 'cms-article-page'
				, 'view': ArticlePageModuleView
				, 'defaultTemplate': {
						'name': 'ArticlePageTemplate.tpl'
						, 'displayName': 'Article Page Default Template'
						, 'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-2row_tallTop.svg'))
			       }
			});

            pageType.registerPageType({
				'name': 'cms-instruction-page'
				, 'view': InstructionPageModuleView
				, 'defaultTemplate': {
						'name': 'InstructionPageTemplate.tpl'
						, 'displayName': 'Instruction Page Default Template'
						, 'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-hdr_full.svg'))
			       }
			});

            pageType.registerPageType({
				'name': 'cms-tools-page'
				, 'view': ToolPageModuleView
				, 'defaultTemplate': {
						'name': 'ToolPageTemplate.tpl'
						, 'displayName': 'Tool Page Default Template'
						, 'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-hdr_2column_leftNarrow.svg'))
			       }
			});

            pageType.registerPageType({
				'name': 'cms-product-overview-page'
				, 'view': ProductOverviewPageModuleView
				, 'defaultTemplate': {
						'name': 'ProductOverviewPageTemplate.tpl'
						, 'displayName': 'Product Overview Page Default Template'
						, 'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-full.svg'))
			       }
			});

            pageType.registerTemplate({
			pageTypes: ['cms-article-page','ProductDetails.Full.View','cms-landing-page']
			, template: {
						'name': 'ArticlePageTemplate.tpl'
					, 	'displayName': 'Article Page Alternate Template'
					,	'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-2row_tallTop.svg'))
                }
            });

            pageType.registerTemplate({
			pageTypes: ['cms-instruction-page','ProductDetails.Full.View','cms-landing-page']
			, template: {
						'name': 'InstructionPageTemplate.tpl'
					, 	'displayName': 'Instruction Page Alternate Template'
					,	'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-hdr_full.svg'))
                }
            });

            pageType.registerTemplate({
			pageTypes: ['cms-tools-page','ProductDetails.Full.View','cms-landing-page']
			, template: {
						'name': 'ToolPageTemplate.tpl'
					, 	'displayName': 'Tools Page Alternate Template'
					,	'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-hdr_2column_leftNarrow.svg'))
                }
            });

            pageType.registerTemplate({
			pageTypes: ['cms-product-overview-page','ProductDetails.Full.View','cms-landing-page']
			, template: {
						'name': 'ProductOverviewPageTemplate.tpl'
					, 	'displayName': 'Produt Overview Page Alternate Template'
					,	'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/smtLayout-full.svg'))
                }
            });

			// pageType.registerTemplate({
			// pageTypes: ['cms-instruction-page','ProductDetails.Full.View','cms-landing-page']
			// , template: {
			// 			'name': 'ArticlePageTemplate2.tpl'
			// 		, 	'displayName': 'Article Page Alternate Template'
			// 		,	'thumbnail': Utils.getAbsoluteUrl(getExtensionAssetsPath('img/thumbnail_2.png'))
            //     }
            // });
			/** @type {LayoutComponent} */
		}
	};
});
